import type { getReferenceReturn, ReferencesProviderInterface } from "hooks/reference";

const formatReferencesValues = (
    reference: ReferencesProviderInterface,
    referenceName: keyof getReferenceReturn,
    referenceData: string | string[] | null | undefined
): string => {
    let referenceValue = "";
    const referenceType = referenceData;

    if (Array.isArray(referenceType) && referenceType.length > 1) {
        referenceType.forEach((device, index) => {
            const refValue = reference.get(referenceName, device)?.value;
            const refText = refValue === undefined || refValue === null ? "" : String(refValue);
            referenceValue += index === 0 ? refText : `, ${refText}`;
        });
    } else {
        const key = typeof referenceData === "string" ? referenceData : "";
        const refValue = key ? reference.get(referenceName, key)?.value : "";
        referenceValue = refValue === undefined || refValue === null ? "" : String(refValue);
    }

    return referenceValue;
};

export default formatReferencesValues;
